import React, { PureComponent } from 'react';
import Modal from 'eventbrite_design_system/modal/Modal';
import transform from '../transform';
import defaultSettings from './settings';

import Packages from '../../components/Packages';
import {
    GA_COPY_MIGRATION_PACKAGE_SELECTION_VIEW,
    GA_CREATE_MIGRATION_PACKAGE_SELECTION_VIEW,
    GA_LABEL,
    GA_MIGRATION_CATEGORY,
} from '../../constants/analytics';
import { PACKAGE_SELECTION_PAGE } from '../../constants/main';

import './packageSelectionPage.scss';

export default class PackageSelectionPage extends PureComponent {
    componentDidMount() {
        const { isCreate, isCopy, trackEvent } = this.props;

        if (isCreate) {
            trackEvent({
                action: GA_CREATE_MIGRATION_PACKAGE_SELECTION_VIEW,
                label: GA_LABEL,
                category: GA_MIGRATION_CATEGORY,
            });
        } else if (isCopy) {
            trackEvent({
                action: GA_COPY_MIGRATION_PACKAGE_SELECTION_VIEW,
                label: GA_LABEL,
                category: GA_MIGRATION_CATEGORY,
            });
        }
    }

    render() {
        const {
            locale,
            isAuthenticated,
            assortmentsPricing,
            assortmentsTax,
            hasFixedFee,
            referer,
            isCopy,
            isCreate,
            setPackageOne,
            setPackageTwo,
            redirectToContactSales,
            redirectToReferer,
            copySetPackageTwo,
            onboardingRedirectToContactSales,
            goToOverviewPage,
        } = this.props;
        const { packagesList } = transform({
            locale,
            isAuthenticated,
            defaultSettings,
            page: PACKAGE_SELECTION_PAGE,
        });
        let CTAActions = [setPackageOne, setPackageTwo, redirectToContactSales];
        const learnMoreActions = Array(3).fill(goToOverviewPage);
        const modalAnimOverrideClassName = {
            __className: 'marketing-modal--no-anim',
        };

        if (isCopy) {
            CTAActions = [
                setPackageOne,
                copySetPackageTwo,
                onboardingRedirectToContactSales,
            ];
        }

        if (isCreate) {
            CTAActions = [
                setPackageOne,
                setPackageTwo,
                onboardingRedirectToContactSales,
            ];
        }

        return (
            <div className="eds-bg-color--grey-100">
                <div className="marketing-modal__container" />
                <Modal
                    type="complex"
                    isShown={true}
                    onClose={redirectToReferer.bind(this, referer)}
                    dangerouslySetContainerClassName={
                        modalAnimOverrideClassName
                    }
                >
                    <div className="eds-g-grid eds-bg-color--grey-100">
                        <Packages
                            {...packagesList}
                            pricing={assortmentsPricing}
                            hasFixedFee={hasFixedFee}
                            CTAActions={CTAActions}
                            learnMoreActions={learnMoreActions}
                            isCopy={isCopy}
                            fixedHeight={true}
                            taxLabel={assortmentsTax}
                        />
                    </div>
                </Modal>
            </div>
        );
    }
}
